// @flow

import React, { type Node, Component } from 'react';
import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { RenderErrorPage } from './render-error-page';
import { FatalErrorPage } from './fatal-error-page';
import { handleError } from '@tectonics/alert-handler';

type Props = {|
  incomingPayment?: IncomingPayment,
  children: Node,
|};

type State = {|
  error: ?Error,
|};

export class FallbackErrorBoundary extends Component<Props, State> {
  state = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack: string }) {
    Object.assign(error, {
      stack: `[FallbackErrorBoundary]\nError stack:\n${error.stack}\nComponent stack:\n${errorInfo.componentStack}`,
    });
    handleError(error);
  }

  render(): Node {
    if  (!this.state.error) {
      return this.props.children;
    }

    const { incomingPayment } = this.props;

    if (incomingPayment && incomingPayment.status) {
      return (
        <RenderErrorPage
          status={incomingPayment.status}
          country={incomingPayment.country}
          error={this.state.error}
        />
      );
    }

    return <FatalErrorPage error={this.state.error}/>;
  }
}
